/* ETHIQZ — storefront behaviour. All init is idempotent so the theme editor can re-run it. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  function initReveals(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;

    if (reduceMotion || !window.ETHIQZ || !window.ETHIQZ.settings.reveals || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- price reveal ---------- */
  function initPriceReveal(root) {
    var scope = root || document;
    scope.querySelectorAll('.price-reveal:not(.in)').forEach(function (el) {
      if (reduceMotion || !('IntersectionObserver' in window)) { el.classList.add('in'); return; }
      /* fires once the block reaches the upper 60% of the viewport,
         matching the prototype's buy-section trigger */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -40% 0px' });
      io.observe(el);
    });
  }

  /* ---------- reading progress ---------- */
  function initProgress() {
    var bar = document.getElementById('progress');
    if (!bar || reduceMotion) return;
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ---------- mobile nav + search ---------- */
  function initHeader(root) {
    var scope = root || document;
    var toggle = scope.querySelector('.menu-toggle');
    var links = scope.querySelector('.nav-links');
    if (toggle && links && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', function () {
        var open = links.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var searchBtn = scope.querySelector('[data-search-toggle]');
    var panel = scope.querySelector('.search-panel');
    if (searchBtn && panel && !searchBtn.dataset.bound) {
      searchBtn.dataset.bound = '1';
      searchBtn.addEventListener('click', function () {
        var open = panel.classList.toggle('open');
        searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }
  }

  /* ---------- the meditation scroll story ----------
     The cap does not spin. It turns gently from -24deg to +24deg while
     floating up and breathing in scale, following a sine arc across the
     scroll. These numbers are the prototype's. */
  function initStory(root) {
    var scope = root || document;
    var track = scope.querySelector('[data-story-track]');
    if (!track) return;

    var cap = track.querySelector('[data-story-cap]');
    var specs = Array.prototype.slice.call(track.querySelectorAll('.spec'));
    var dots = Array.prototype.slice.call(track.querySelectorAll('.story-dots span'));
    if (!specs.length) return;

    var mobile = window.matchMedia('(max-width: 960px)').matches;

    function showAll() {
      specs.forEach(function (s) { s.classList.add('show'); });
      if (cap) cap.style.transform = '';
    }

    function onScroll() {
      if (reduceMotion || mobile) { showAll(); return; }

      var rect = track.getBoundingClientRect();
      var total = track.offsetHeight - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var prog = total > 0 ? scrolled / total : 0;

      var arc = Math.sin(prog * Math.PI);

      if (cap) {
        cap.style.transform =
          'rotateX(' + (-6 + arc * 6).toFixed(2) + 'deg) ' +
          'rotateY(' + (-24 + prog * 48).toFixed(2) + 'deg) ' +
          'translateY(' + (arc * -14).toFixed(2) + 'px) ' +
          'scale(' + (0.94 + arc * 0.08).toFixed(3) + ')';
      }

      var idx = Math.min(specs.length - 1, Math.floor(prog * specs.length));
      specs.forEach(function (s, i) { s.classList.toggle('show', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    }

    function rest() {
      if (reduceMotion || mobile) {
        showAll();
      } else {
        specs.forEach(function (s, i) { s.classList.toggle('show', i === 0); });
        if (cap) cap.style.transform = 'rotateY(-24deg)';
        onScroll();
      }
    }

    if (track.dataset.bound) { rest(); return; }
    track.dataset.bound = '1';

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      mobile = window.matchMedia('(max-width: 960px)').matches;
      rest();
    }, { passive: true });

    rest();

    /* theme editor: selecting a panel scrolls to where it appears */
    document.addEventListener('shopify:block:select', function (event) {
      if (!track.contains(event.target)) return;
      if (mobile || reduceMotion) { event.target.scrollIntoView({ block: 'center' }); return; }
      var i = specs.indexOf(event.target);
      if (i < 0) return;
      var total = track.offsetHeight - window.innerHeight;
      window.scrollTo({ top: track.offsetTop + (total * ((i + 0.5) / specs.length)), behavior: 'auto' });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';

      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.galleryThumb;
          if (thumb.dataset.galleryThumbSrcset) main.srcset = thumb.dataset.galleryThumbSrcset;
          main.alt = thumb.dataset.galleryThumbAlt || '';
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('sel'); });
          thumb.classList.add('sel');
        });
      });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      var dataEl = form.querySelector('[data-variant-json]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var priceNow = form.querySelector('[data-price-now]');
      var priceWas = form.querySelector('[data-price-was]');
      var submit = form.querySelector('[data-add-button]');
      var label = form.querySelector('[data-option-label]');
      var gallery = document.querySelector('[data-gallery]');

      function selected() {
        var values = [];
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var active = group.querySelector('[aria-checked="true"]');
          values[parseInt(group.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
        });
        return values;
      }

      function match(values) {
        return variants.find(function (v) {
          return values.every(function (val, i) { return val === null || v.options[i] === val; });
        });
      }

      function render() {
        var values = selected();
        var variant = match(values);

        /* grey out combinations that do not exist */
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          group.querySelectorAll('[data-value]').forEach(function (btn) {
            var probe = values.slice();
            probe[idx] = btn.dataset.value;
            var found = variants.find(function (v) {
              return probe.every(function (val, i) { return val === null || v.options[i] === val; });
            });
            btn.disabled = !found || !found.available;
          });
        });

        if (label) {
          label.textContent =
            (label.dataset.prefix || '') +
            values.filter(Boolean).join(' · ') +
            (label.dataset.suffix || '');
        }

        if (!variant) {
          if (submit) { submit.disabled = true; submit.textContent = window.ETHIQZ.strings.unavailable; }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceNow) priceNow.innerHTML = formatMoney(variant.price);
        if (priceWas) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceWas.innerHTML = formatMoney(variant.compare_at_price);
            priceWas.hidden = false;
          } else {
            priceWas.hidden = true;
          }
        }

        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available
            ? window.ETHIQZ.strings.addToBag + ' — ' + stripTags(formatMoney(variant.price))
            : window.ETHIQZ.strings.soldOut;
        }

        if (variant.featured_image && gallery) {
          var main = gallery.querySelector('[data-gallery-main]');
          if (main) { main.src = variant.featured_image.src; main.removeAttribute('srcset'); }
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      form.querySelectorAll('[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var group = btn.closest('[data-option-index]');
          group.querySelectorAll('[data-value]').forEach(function (b) {
            b.setAttribute('aria-checked', 'false');
            b.classList.remove('sel');
          });
          btn.setAttribute('aria-checked', 'true');
          btn.classList.add('sel');
          render();
        });
      });

      render();
    });
  }

  /* ---------- quantity steppers ---------- */
  function initQty(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-qty]').forEach(function (widget) {
      if (widget.dataset.bound) return;
      widget.dataset.bound = '1';
      var input = widget.querySelector('input');
      widget.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.qtyStep, 10);
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- floating promo ---------- */
  function initPromo(root) {
    var scope = root || document;
    var banner = scope.querySelector('[data-promo-banner]');
    if (!banner || banner.dataset.bound) return;
    banner.dataset.bound = '1';

    var key = 'ethiqz:promo-dismissed';
    var days = parseInt(banner.dataset.dismissDays, 10) || 0;

    /* in the theme editor, always show it so the merchant can see what they edit */
    var inEditor = window.Shopify && window.Shopify.designMode;

    if (days > 0 && !inEditor) {
      try {
        var until = parseInt(window.localStorage.getItem(key), 10);
        if (until && Date.now() < until) return;
      } catch (e) { /* private mode — just show it */ }
    }

    var delay = inEditor ? 0 : (parseInt(banner.dataset.delay, 10) || 0);
    setTimeout(function () { banner.classList.add('in'); }, delay);

    var close = banner.querySelector('[data-promo-close]');
    if (close) {
      close.addEventListener('click', function () {
        banner.classList.remove('in');
        if (days > 0) {
          try {
            window.localStorage.setItem(key, String(Date.now() + days * 86400000));
          } catch (e) { /* nothing to do */ }
        }
      });
    }
  }

  /* ---------- money ---------- */
  function stripTags(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.textContent || '';
  }

  function formatMoney(cents) {
    var format = (window.ETHIQZ && window.ETHIQZ.moneyFormat) || '₹{{amount}}';
    var value = cents / 100;

    function withCommas(num, decimals) {
      var fixed = num.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, '.');
        default: return withCommas(value, 2);
      }
    });
  }

  /* ---------- boot ---------- */
  function initAll(root) {
    initReveals(root);
    initPriceReveal(root);
    initHeader(root);
    initStory(root);
    initGallery(root);
    initVariants(root);
    initQty(root);
    initPromo(root);
  }

  window.ETHIQZ_UI = { initAll: initAll, formatMoney: formatMoney };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initProgress(); });
  } else {
    initAll();
    initProgress();
  }

  /* theme editor hooks */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var track = e.target.querySelector('[data-story-track]');
    if (track) delete track.dataset.bound;
  });
})();
